import React from "react";
import BioMedicalWasteFormPage from "../components/bio-medical-waste/BioMedicalWasteFormPage";

const BioMedicalWasteCreate = () => <BioMedicalWasteFormPage mode="create" />;

export default BioMedicalWasteCreate;

